import ReactGA from "react-ga4";

export default function start_google_analytics_4(
    toolState,
    gaInitialized,
    setGaInitialized,
    listen
) {
    if (!gaInitialized) {
        ReactGA.initialize(toolState.google_analytics_4);
        ReactGA.set({ anonymizeIp: true });
        setGaInitialized(true);
    }
    ReactGA.ga(
        "set",
        "page",
        window.location.pathname + window.location.search
    );
    ReactGA.ga("send", "pageview");
    const unlisten = listen((location) => {
        ReactGA.ga("set", "page", location.pathname + location.search);
        ReactGA.ga("send", "pageview");
    });

    return unlisten;
}
